import { reject } from 'lodash'
import *  as types from './mutation-types'

export const fetchDeliveryNotes =({commit, dispatch, state}, params)=>{
   return new Promise((resolve, reject)=>{
       window.axios.get(`/api/deliveryNotes`, { params }).then((response)=>{
           commit(types.SET_DELIVERYNOTES, response.data.deliveryNotes.data)
           commit(types.SET_TOTAL_DELIVERYNOTES, response.data.deliveryNotes.total)
           resolve(response)
       }).catch((err)=>reject(err))
   });
}
export const addDeliveryNote = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('/api/deliveryNotes', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const deleteDeliveryNote = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`/api/deliveryNotes/${id}`).then((response) => {
            commit(types.DELETE_DELIVERY_NOTE, id)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const fetchCreateDeliveryNote = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/deliveryNotes/create`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const resetPOHasItem = ({ commit, dispatch, state }, id)=>{
    commit(types.PO_HAS_ITEM, false)
}
export const resetAvailableDeliveryNoteItems = ({ commit, dispatch, state }, id)=>{
    commit(types.SET_DELIVERYNOTE_ITEMS, [])
}
export const resetDeliveryNoteItemsStatus = ({ commit, dispatch, state }, id)=>{
    commit(types.SET_DELIVERYNOTE_ITEMS_STATUS, false)
}
export const resetPOItems = ({ commit, dispatch, state }, id) => {
    commit(types.SET_PO_ITEM, [])
}
export const reselectAllDeliveryNoteItems = ({ commit, dispatch, state }, id) => {
    commit(types.SET_PO_ITEM, [])
    commit(types.SET_SELECTED_DELIVERYNOTE_ITEMS, [])
    commit(types.SET_SELECT_ALL_STATE_ITEM, false)
}
export const fetchDeliveryNote = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/deliveryNotes/${id}/edit`).then((response) => {
            if (response.data.deliveryNote.purchase_order.items && response.data.deliveryNote.purchase_order.items.length>0){
                commit(types.PO_HAS_ITEM, true)
                if (response.data.deliveryNote.items.length > 0 && response.data.poItems.length>=0){
                    commit(types.SET_DELIVERYNOTE_ITEMS, response.data.deliveryNote.items)
                    commit(types.SET_PO_ITEM, response.data.poItems)
                    commit(types.SET_DELIVERYNOTE_ITEMS_STATUS, true)
                } else if(response.data.deliveryNote.items.length > 0 ){
                    commit(types.SET_DELIVERYNOTE_ITEMS_STATUS, true)
                    commit(types.AVAILABLE_DELIVERYNOTE_ITEMS, response.data.items)
                }else{
                    commit(types.SET_DELIVERYNOTE_ITEMS_STATUS, false)
                    commit(types.AVAILABLE_DELIVERYNOTE_ITEMS, response.data.items)
                }

            }else{
                commit(types.PO_HAS_ITEM, false)
                if (response.data.deliveryNote.items.length > 0) {
                    commit(types.SET_DELIVERYNOTE_ITEMS, response.data.deliveryNote.items)
                    commit(types.SET_DELIVERYNOTE_ITEMS_STATUS, true)
                    commit(types.AVAILABLE_DELIVERYNOTE_ITEMS, response.data.items)
                } else {
                    commit(types.SET_DELIVERYNOTE_ITEMS_STATUS, false)
                    commit(types.AVAILABLE_DELIVERYNOTE_ITEMS, response.data.items)
                }
            }
            commit(types.SET_TEMPLATE_ID, response.data.deliveryNote.delivery_note_template_id)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const fetchViewDeliveryNote = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/deliveryNotes/${id}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const searchDeliveryNote = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/deliveryNotes?${data}`).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const updateDeliveryNote = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`/api/deliveryNotes/${data.id}`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const selectdDeliveryNote = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_DELIVERYNOTES, data)
    if (state.selectedDeliveryNotes.length === state.deliveryNotes.length) {
        commit(types.SET_SELECT_ALL_STATE, true)
    } else {
        commit(types.SET_SELECT_ALL_STATE, false)
    }
}
export const setSelectAllState = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_STATE, data)
}
export const selectAllDeliveryNotes = ({ commit, dispatch, state }) => {
    if (state.selectedDeliveryNotes.length === state.deliveryNotes.length) {
        commit(types.SET_SELECTED_DELIVERYNOTES, [])
        commit(types.SET_SELECT_ALL_STATE, false)
    } else {
        let alldeliveryNotes = state.deliveryNotes.map(deliveryNote => deliveryNote.id)
        commit(types.SET_SELECTED_DELIVERYNOTES, alldeliveryNotes)
        commit(types.SET_SELECT_ALL_STATE, true)
    }
}
// deliverynote item
export const selectedDeliveryNoteItem = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECTED_DELIVERYNOTE_ITEMS, data)
    if (state.selectedDeliveryNoteItems.length === state.deliveryNoteItems.length) {
        commit(types.SET_SELECT_ALL_STATE_ITEM, true)
    } else {
        commit(types.SET_SELECT_ALL_STATE_ITEM, false)
    }
}
export const setSelectAllStateItem = ({ commit, dispatch, state }, data) => {
    commit(types.SET_SELECT_ALL_STATE_ITEM, data)
}
export const selectAllDeliveryNoteItems = ({ commit, dispatch, state }) => {
    if (state.selectedDeliveryNoteItems.length === state.deliveryNoteItems.length) {
        console.log('lll')
        commit(types.SET_SELECTED_DELIVERYNOTE_ITEMS, [])
        commit(types.SET_SELECT_ALL_STATE_ITEM, false)
    } else {
        console.log(state.deliveryNoteItems)
        let alldeliveryNotes = state.deliveryNoteItems.map(deliveryNote => deliveryNote.systemItemId)
        commit(types.SET_SELECTED_DELIVERYNOTE_ITEMS, alldeliveryNotes)
        commit(types.SET_SELECT_ALL_STATE_ITEM, true)
    }
}

export const resetSelectedDeliveryNotes = ({ commit, dispatch, state }) => {
    commit(types.RESET_SELECTED_DELIVERYNOTES)
}
export const selectCustomer = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`/api/customers/${id}`).then((response) => {
            commit(types.RESET_SELECTED_CUSTOMER)
            commit(types.SELECT_CUSTOMER, response.data.customer)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const resetSelectedCustomer = ({ commit, dispatch, state }, data) => {
    commit(types.RESET_SELECTED_CUSTOMER)
}

export const markAsStable = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/deliveryNotes/mark-as-confirmed`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}
export const convertToInvoice = ({ commit, dispatch, state },data) => {
    return new Promise((resolve, reject) => {
        window.axios.post(`/api/deliveryNotes/convert-to-invoice`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const removeDeliveryNoteItem = ({ commit, dispatch, state }, data) => {
    commit(types.DELETE_DELIVERY_NOTE_ITEM, data)
}
export const deleteMultipleItems = ({ commit, dispatch, state }, id) => {
    //commit(types.ADD_MULTIPLE_PO_ITEM, state.selectedDeliveryNoteItems)
    commit(types.DELETE_DELIVERY_NOTE_MULTIPLE_ITEMS, state.selectedDeliveryNoteItems)
    commit(types.SET_SELECT_ALL_STATE_ITEM, false)
}
export const addDeliveryNoteItem = ({ commit, dispatch, state }, data) => {
  commit(types.ADD_DELIVERY_NOTE_ITEMS, data)
}
export const updateDeliveryNoteItem = ({ commit, dispatch, state }, data) => {
  commit(types.UPDATE_DELIVERY_NOTE_ITEM, data)
}
export const removeInPOItems = ({ commit, dispatch, state }, data) => {
    commit(types.DELETE_PO_ITEM, data)
}

export const tempDeleteItem = ({ commit, dispatch, state }, data) => {
    commit(types.TEMP_DELETE_ITEM, data)
}
export const tempAddItem = ({ commit, dispatch, state }, data) => {
    commit(types.TEMP_ADD_ITEM, data)
}

